import { makeStyles } from '@material-ui/core'
import React from 'react'
import { tokens } from './tokens'

const useStyles = makeStyles(() => ({
    container: {
        width: '100%',
        maxWidth: tokens.containerW,
        margin: '0 auto',
        padding: '0 24px',
    },
}))

export function Container({ className = '', children, ...rest }) {
    const classes = useStyles()
    return (
        <div className={`${classes.container} ${className}`} {...rest}>
            {children}
        </div>
    )
}
